<div class="recu-container print" fxLayout="column" fxLayoutAlign="center">
    <div *ngIf="pathName !== 'welcome'" class="footer mb-32 ml-auto no-print" (click)="print()" style="color: rgb(0, 162, 255);cursor: pointer;" fxLayout="row" fxLayoutAlign="center center">
        {{ 'receipt.print' | transloco }}
    </div>
    <div class="header my-20 mx-auto">
        <!-- <img src="assets/icons/icon-96x96.png" alt="logo autoecoleplus.tn"> -->
        <img src="assets/icons/check.png" alt="logo autoecoleplus.tn" class="success-icon">
        <div class="header-text mt-12" fxLayout="column" fxLayoutAlign="center">
            <span class="main-text">{{ 'receipt.paymentSuccess' | transloco }}</span>
            <span class="secondary-text">{{ 'receipt.purchaseThanks' | transloco }}</span>
        </div>
    </div>
    <div class="main" fxLayout="column" fxLayoutGap="20px">
        <div class="line" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="col1">{{ 'receipt.client' | transloco }}</span>
            <!-- <span class="col2">{{user.prenom}} {{user.nom}}</span> -->
            <span class="col2">{{data.fullname}}</span>
        </div>
        <div class="line" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="col1">{{ 'receipt.amount' | transloco }}</span>
            <span class="col2">{{data.received_amount | number :'1.3-3'}} DT</span>
        </div>
        <div class="line" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="col1">{{ 'receipt.date' | transloco }}</span>
            <span class="col2">{{now | date}}</span>
        </div>
        <div class="line" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="col1">{{ 'receipt.method' | transloco }}</span>
            <span class="col2">{{ 'receipt.bankCard' | transloco }}</span>
        </div>

        <div class="footer mt-32 no-print" fxLayout="row" fxLayoutAlign="center center">
            <a [routerLink]="['/' + pathName + '/contract']" routerLinkActive="router-link-active" class="mt-80 foote">
                {{ 'receipt.returnTo' | transloco }} {{ pathName === 'welcome' ? ('receipt.home' | transloco) : ('receipt.billing' | transloco) }}
              </a>
              
        </div>

    </div>
</div>
